import React from "react";
import { Routes } from "react-router-dom";

import SchoolRoutes from "./SchoolRoutes";
import EducationRoutes from "./EducationRoutes";

export default function AppRouter({ state }) {
  return (
    <Routes>
      {SchoolRoutes({ state })}
      {EducationRoutes({ state })}
    </Routes>
  );
}